import React, { FC } from 'react'
import styled from 'styled-components'

import { Props as ImageProps } from '../image'

export type DotsProps = {
  slidesCount: number
  activeSlide?: number
  visible?: boolean
}

export type DotProps = {
  active: boolean
}

export const Dots: FC<DotsProps> = ({ slidesCount, activeSlide = 0, visible = false, ...restProps }) => {
  return (
    <StyledDots visible={visible} {...restProps}>
      {Array.from({ length: slidesCount }, (_, i) => (
        <Dot key={i} active={activeSlide === i} />
      ))}
    </StyledDots>
  )
}

const Dot: FC<DotProps> = ({ active = false, ...restProps }) => {
  return <StyledDot active={active} {...restProps} />
}

const StyledDots = styled.div<{ visible: boolean }>`
  position: absolute;
  display: flex;
  bottom: ${({ theme }) => theme.spacing[3]};
  padding: 0;
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.3s;
  opacity: ${({ visible }) => (visible ? '1' : '0')};
`

const StyledDot = styled.span<DotProps>`
  width: ${({ theme }) => theme.spacing[1]};
  height: ${({ theme }) => theme.spacing[1]};
  border-radius: 50%;

  &:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing[2]};
  }
  background: ${({ active, theme }) => (active ? theme.palette.brand.primary : theme.palette.grey[300])};
`
